import { useEffect, useState, useContext, useCallback } from 'react';
import { isMobile, isTablet } from 'react-device-detect';

import { ThemeProvider } from 'styled-components';

import { Context } from '@store/store';

import Main from './main';
import MainMobile from './main-mobile';

import { getTheme } from './utils/getTheme';
import { customTheme } from './themes/customTheme';

function App() {
  const [state, dispatch] = useContext(Context);
  const [bookId, setBookId] = useState(null);

  const colorParams = new URLSearchParams(window.location.search).get('color');

  let currentTheme = getTheme(state.activeTheme);
  if (colorParams) {
    currentTheme = customTheme(colorParams.split(','));
  }

  const handleKeyDown = useCallback(e => {
    // arrow left keyCode — 37
    // arrow right keyCode — 39
    if (e.target.matches('input')) {
      return;
    }
    if (e.keyCode === 37) {
      dispatch({ type: 'SET_PREV_PAGE' });
    } else if (e.keyCode === 39) {
      dispatch({ type: 'SET_NEXT_PAGE' });
    }
  }, []);

  useEffect(() => {
    const bookId = parseInt(
      window.location.pathname
        .split('/')
        .filter(item => item)
        .slice(-1)[0],
      10,
    );
    setBookId(bookId);
    dispatch({ type: 'SET_BOOK_ID', payload: bookId });

    const params = new URLSearchParams(window.location.search);
    const efedNoAuth = params.get('efed-noauth');
    if (efedNoAuth === '1') {
      dispatch({ type: 'SET_EFED_NOAUTH', payload: true });
    }

    document.addEventListener('keydown', handleKeyDown, false);

    return () => document.removeEventListener('keydown', handleKeyDown, false);
  }, []);

  return (
    bookId && (
      <ThemeProvider theme={currentTheme}>
        {isMobile && !isTablet ? (
          <MainMobile bookId={bookId} />
        ) : (
          <Main bookId={bookId} />
        )}
      </ThemeProvider>
    )
  );
}

export default App;
